import { FunctionComponent } from 'react'
import { PageEnum } from '.'
import LightHeader from './lightHeader'
import SelectedModel from './selectedModel'
import ThickHeader from './thickHeader'

interface IProps {
  page: PageEnum
  onOpen: () => void
  onClose: () => void
  setPage: React.Dispatch<React.SetStateAction<PageEnum>>
}

const PageHeader: FunctionComponent<IProps> = ({
  page,
  onClose,
  onOpen,
  setPage,
}) => {
  return (
    <>
      {page === PageEnum.DesignYourOwn && (
        <SelectedModel
          onClose={onClose}
          // tools={['configuration']}
          setPage={setPage}
        />
      )}
      {page !== PageEnum.DesignYourOwn && (
        <>
          {page !== PageEnum.ProductConfiguration && (
            <LightHeader page={page} onClose={onClose} setPage={setPage} />
          )}
          {page === PageEnum.ProductConfiguration && (
            <ThickHeader
              page={page}
              onClose={onClose}
              onOpen={onOpen}
              setPage={setPage}
            />
          )}
        </>
      )}
    </>
  )
}

export default PageHeader
